import gql from "graphql-tag";

export const RESET_FORGOTTEN_PASSWORD_MUTATION = gql`
  mutation resetForgottenPassword($resetToken: String!, $email: String!, $newPassword: String!, $newPasswordRepeat: String!) {
    resetForgottenPassword(resetToken: $resetToken, email: $email, newPassword: $newPassword, newPasswordRepeat: $newPasswordRepeat)
  }
`;